import { render, staticRenderFns } from "./checkgroup.vue?vue&type=template&id=0a2bcedf&scoped=true&"
import script from "./checkgroup.vue?vue&type=script&lang=js&"
export * from "./checkgroup.vue?vue&type=script&lang=js&"
import style0 from "./checkgroup.vue?vue&type=style&index=0&id=0a2bcedf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2bcedf",
  null
  
)

export default component.exports